import "../../styles/order/QAControls.scss";

interface Props {
    isQAMode: boolean;
    profile: string;
    onToggle: () => void;
    onSwitchProfile: () => void;
}

export default function QAControls({ isQAMode, profile, onToggle, onSwitchProfile }: Props) {
    if (!isQAMode) return null;

    return (
        <div className="qa-controls">
            <div className="qa-toggle">
                <label className="qa-switch">
                    <input 
                        type="checkbox" 
                        checked={isQAMode}
                        onChange={onToggle}
                    />
                    <span className="qa-slider"></span>
                </label>
                <span className="qa-label">🔧 QA Mode</span>
            </div>
            <div className="qa-profile">
                <span className={`profile-badge ${profile}`}>
                    {profile === 'seller' ? '🏪 Продавец' : '🛒 Покупатель'}
                </span>
                <button className="btn btn-small" onClick={onSwitchProfile}>
                    🔄 Сменить профиль
                </button>
            </div>
        </div>
    );
}
